'use strict';

exports.__esModule = true;

var _Prompt = require('react-router/Prompt');

var _Prompt2 = _interopRequireDefault(_Prompt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/Prompt.js
// module id = 421
// module chunks = 168707334958949